import { GET_ALL_LUNCH_BY_USER, GET_NEXT_LUNCH_DATE } from "@/GraphQL/Queries";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import { useState } from "react";
import { Button, Card, CardBody, Table } from "reactstrap";
import { Pagination } from "@mui/material";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import LunchModal from "./LunchModal";
import Swal from "sweetalert2";
import {
  CREATE_LUNCH_PULL,
  DELETE_LUNCH_PULL,
  UPDATE_LUNCH_PULL,
} from "@/GraphQL/Mutation";
import { decryption } from "../HelperFunctions";
import { useHistory } from "react-router";
import EditIcon from "@mui/icons-material/Edit";
export default function LunchPull(user_id) {
  const history = useHistory();
  const userId = user_id?.user_id;
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );

  const [user, setUser] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const openEditModal = (user) => {
    setUser(user);
    setEditModalOpen(true);
  };
  const closeEditModal = () => {
    setEditModalOpen(false);
    // setSelectedFamily(null);
  };
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const modalHandler = () => {
    setModal((prevSate) => !prevSate);
  };
  const { data, loading, error, refetch } = useQuery(GET_ALL_LUNCH_BY_USER, {
    variables: { user_id: Number(userId), page: currentPage, size: limit },
    fetchPolicy: "network-only",
  });
  const { data: nextDate, loading: nextLoading } =
    useQuery(GET_NEXT_LUNCH_DATE);

  const [createLunchPull, { loading: submitLoading }] =
    useMutation(CREATE_LUNCH_PULL);

  const handleChange = (e, p) => {
    setCurrentPage(p);
    refetch({
      page: p,
    });
  };

  const openModal = async (userId) => {
    const result = await Swal.fire({
      title: "Add Lunch?",
      text: "Do you want to pull lunch for this user?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, add it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const variables = {
          lunch_date_id: Number(nextDate?.getNextLunchDate?.id),
          has_lunch: true,
          user_id: Number(userId),
        };

        const res = await createLunchPull({ variables });
        if (res?.data?.createLunchPull?.result_code === "000") {
          Swal.fire("✅ Success", "Lunch pull added successfully!", "success");
          refetch();
        } else {
          Swal.fire(
            "⚠️ Failed",
            `${res?.data?.createLunchPull?.status}`,
            "error"
          );
        }
      } catch (err) {
        console.error("❌ Error creating lunch pull:", err);
        Swal.fire("❌ Error", "An error occurred. Please try again.", "error");
      }
    }
  };

  const [updateLunchPull, { loading: updateLoading }] =
    useMutation(UPDATE_LUNCH_PULL);
  const [deleteLunchPull, { loading: deleteLoading }] =
    useMutation(DELETE_LUNCH_PULL);

  const openModalEdit = async (userItem) => {
    const alreadyHasLunch = userItem?.has_lunch === true;
    const actionText = alreadyHasLunch ? "Remove Lunch?" : "Add Lunch?";
    const confirmText = alreadyHasLunch ? "Yes, remove it!" : "Yes, add it!";
    const successMessage = alreadyHasLunch
      ? "Lunch pull removed successfully!"
      : "Lunch pull added successfully!";
    const updatedHasLunch = !alreadyHasLunch;

    const result = await Swal.fire({
      title: actionText,
      text: `Do you want to ${
        alreadyHasLunch ? "remove" : "add"
      } lunch for this user?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      let res;
      res = await deleteLunchPull({
        variables: {
          id: userItem.id,
        },
      });

      const resultCode = res?.data?.deleteLunchPull?.result_code;

      const status = res?.data?.deleteLunchPull?.status;

      if (resultCode === "001") {
        Swal.fire("✅ Success", successMessage, "success");
        refetch();
      } else {
        Swal.fire("⚠️ Failed", status, "error");
      }
    } catch (err) {
      console.error("❌ Error toggling lunch pull:", err);
      Swal.fire("❌ Error", "An error occurred. Please try again.", "error");
    }
  };
  if (loading) {
    <div className="loader-container">
      <SubmitLoading color="black" />
    </div>;
  }
  return (
    <Card className="mb-3 shadow-sm">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0"> Lunch Pulled History</h4>
          <div>
            <Button color="primary" size="sm" onClick={() => openModal(userId)}>
              Add Lunch
            </Button>
            {permissions?.includes("create lunch") ? (
              <Button
                color="primary"
                size="sm"
                onClick={() =>
                  history.push({
                    pathname: "/profile/lunch",
                  })
                }
                style={{
                  cursor: permissions?.includes("create lunch")
                    ? "pointer"
                    : "default",
                }}
              >
                Lunch list
              </Button>
            ) : null}
          </div>
        </div>
        <div className="mb-3">
          <h6 className="text-muted">
            Total Lunch:{" "}
            <strong className="text-dark">
              {data?.getAllLunchByUser?.paginatorInfo?.total || 0}
            </strong>
          </h6>
        </div>
        <Table bordered striped responsive hover size="sm" className="mb-2">
          <thead className="thead-dark">
            <tr>
              <th style={{ width: "5%" }}>#</th>
              <th style={{ width: "35%" }}>Date</th>
              <th style={{ width: "30%" }}>Lunch Pulled</th>
              <th style={{ width: "10%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.getAllLunchByUser?.data.length > 0 ? (
              data?.getAllLunchByUser?.data?.map((lunch, index) => (
                <tr key={lunch?.id || index}>
                  <td>{index + 1}</td>
                  <td>
                    {moment(lunch?.lunchDateInfo?.lunch_date).format(
                      "MMMM D, YYYY"
                    )}
                  </td>
                  <td>
                    {lunch?.has_lunch ? (
                      <span className="text-success fw-bold">✅ Yes</span>
                    ) : (
                      <span className="text-danger fw-bold">❌ No</span>
                    )}
                  </td>

                  <td>
                    {lunch?.lunchDateInfo?.lunch_date ===
                    nextDate?.getNextLunchDate?.lunch_date ? (
                      <button
                        className="inbox__email-btn mr-1"
                        type="button"
                        aria-label="edit"
                        onClick={() => openModalEdit(lunch)}
                      >
                        <EditIcon fontSize="small" />
                      </button>
                    ) : null}
                  </td>

                  {/* <td>
                    {lunch?.has_lunch ? (
                      <Button size="sm" color="success" onClick={modalHandler}>
                        View Details
                      </Button>
                    ) : (
                      <span className="text-muted">No Action</span>
                    )}
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No lunch records found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <LunchModal
          modal={editModalOpen}
          toggle={closeEditModal}
          userId={userId}
        />

        {data?.getAllLunchByUser?.data.length > 0 ? (
          <Pagination
            className="mt-2"
            count={data?.getAllLunchByUser?.paginatorInfo?.lastPage}
            page={data?.getAllLunchByUser?.paginatorInfo?.currentPage}
            onChange={handleChange}
          />
        ) : null}
      </CardBody>
    </Card>
  );
}
